




































































import { MultiResourceMixin } from '@/mixins/multiResourceMixin'
import { AccountPickerElInterface, Resource } from '@/config/interfaces'

export default MultiResourceMixin.extend({
  name: 'AccountPickerEl',
  props: {
    templateItemData: {
      type: Object as () => AccountPickerElInterface,
      required: true
    }
  },
  computed: {
    inactiveResources (): Array<Resource> {
      return this.$store.getters.getMsisdns.filter((item: Resource) => !item.active)
    },
    activeIdentifier (): Resource {
      return this.$store.getters.getMsisdn
    },
    hasResources (): boolean {
      return this.$store.getters.getMsisdns.length > 0
    },
    hasMultiResource (): boolean {
      return this.$store.getters.getMsisdns.length > 1
    },
    resolveLeftBorderPosition (): boolean {
      return this.$store.getters.getMsisdns.length === 1 && this.isDesktop
    }
  },

  methods: {
    getBarColor (resource: Resource): string {
      return resource.colorSeparator || '#19AAF8'
    }
  },
  mounted () {
    if (!this.hasResources) {
      this.$store.dispatch('commitIdentifiers', this.$props.templateItemData.list)
    }
  }
})
